module.exports = __webpack_public_path__ + "img/fi-rr-shopping-cart-add.fb3cba94.svg";